/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { AxiosResponse } from 'axios';

import { loginApi } from '../../setup/setupApi';
import { OAuthConnectionFieldsType } from './types';

export const getOAuthConnection = (projectId: string): Promise<OAuthConnectionFieldsType> =>
  loginApi.get(`/projects/${projectId}/custom_identity_provider`).then((res) => res.data);

export const createOAuthConnectionFields = (
  projectId: string,
  body: OAuthConnectionFieldsType
): Promise<OAuthConnectionFieldsType> =>
  loginApi
    .post<OAuthConnectionFieldsType, AxiosResponse<OAuthConnectionFieldsType>>(
      `/projects/${projectId}/custom_identity_provider`,
      body
    )
    .then((res) => res.data);

export const updateOAuthConnectionFields = (
  projectId: string,
  body: OAuthConnectionFieldsType
): Promise<OAuthConnectionFieldsType> =>
  loginApi
    .put<OAuthConnectionFieldsType, AxiosResponse<OAuthConnectionFieldsType>>(
      `/projects/${projectId}/custom_identity_provider`,
      body
    )
    .then((res) => res.data);

export const deleteOAuthConnectionFields = (projectId: string) =>
  loginApi.delete(`/projects/${projectId}/custom_identity_provider`).then((res) => res.data);
